import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { BoxTableProps } from './types';
import { BLOCKS, Node } from '@contentful/rich-text-types';
import { liveUpdateAttrs } from 'libs/contentful/utils';

const BoxTable = ({ sys, tableHeader, tableBody }: BoxTableProps) => {
  const additionalOptions = {
    renderNode: {
      [BLOCKS.TABLE_CELL]: (node: Node, children: React.ReactNode) => (
        <td className={`max-sm:block px-4 py-6 text-grey-200 border border-pebble max-sm:border-t-0`}>{children}</td>
      ),
    },
  };

  return (
    <span {...liveUpdateAttrs(sys?.id, 'tableBody')} data-testid="embeddedBoxTable">
      <span className="block w-full font-semibold text-center border border-pebble border-b-0 max-sm:border-b bg-secondary p-6">
        {tableHeader}
      </span>
      <RichTextCopy copy={tableBody} ySpacing={'lg'} additionalOptions={additionalOptions} />
    </span>
  );
};

export default BoxTable;
